var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price",class:'price_' + _vm.type},[_c('span',{staticClass:"price__currency"},[_vm._v("$")]),_c('span',{staticClass:"price__value"},[_vm._v("\n        "+_vm._s(_vm.price)+"\n    ")]),_c('span',{staticClass:"price__period"},[_vm._v("/month")])])
}
var staticRenderFns = []

export { render, staticRenderFns }